import React, { Component } from 'react';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import InstrumentFunctions from '../services/InstrumentService';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';
import Modal from 'react-bootstrap/Modal';

export class ManageAssets extends Component {
    static displayName = ManageAssets.name;

    constructor(props) {
        super(props);

        this.state = {
            isAdmin: false,
            height: 0,
            width: 0,
            showToast: false,
            partNo: '',
            selectedChange: '',
            comments: '',
        };
        this.handleClose = this.handleClose.bind(this);
        window.addEventListener('resize', this.setWindowDimensions);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    handleClose() {
        this.setState({ showToast: false });
    }

    async handleSubmission() {
        var data = { partNo: this.state.partNo, requestedChange: this.state.selectedChange, comments: this.state.comments };

        var response = await InstrumentFunctions.postAssetChangeRequestAsync(data);

        //if (response != null) {
        this.setState({ showToast: true });
        //}
    };

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    render() {
        //Put in logic here! 

        return (
            <div>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{ color: '#233c7c' }}>Manage TICMS Calibrated Assets</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row className="mediumSize">
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ partNo: e.target.value })}
                                        className='fullInput'
                                        placeholder='Enter the R# or M&TE# Here'
                                    />
                                </Col>
                                <Col style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                    {/*TODO: This should display with the R# found*/}
                                    <span style={{ display: 'none' }}></span> 
                                </Col>
                            </Row>
                            <div style={{marginTop: '10px'}}>
                                <Input
                                    type='radio'
                                    name='requestedChange'
                                    id='requestedChange'
                                    onClick={(e) => this.setState({ selectedChange: 'Change a Calibration Interval' })}
                                    className='rightRadios'
                                    placeholder=''
                                /> <span> Change a Calibration Interval</span>
                            </div>
                            <div>
                                <Input
                                    type='radio'
                                    onClick={(e) => this.setState({ selectedChange: 'Change a M&TE' })}
                                    name='requestedChange'
                                    id='requestedChange'
                                    className='rightRadios'
                                    placeholder=''
                                /> <span> Change a M&TE</span>
                            </div>
                            <div>
                                <Input
                                    type='radio'
                                    onClick={(e) => this.setState({ selectedChange: 'Change a Department' })}
                                    name='requestedChange'
                                    id='requestedChange'
                                    className='rightRadios'
                                    placeholder=''
                                /> <span> Change A Department</span>
                            </div>
                            <div>
                                <Input
                                    type='radio'
                                    onClick={(e) => this.setState({ selectedChange: 'Request a Different Calibration Date' })}
                                    name='requestedChange'
                                    id='requestedChange'
                                    className='rightRadios'
                                    placeholder=''
                                /> <span>Request a Different Calibration Date</span>
                            </div>
                            <div>
                                <Input
                                    type='radio'
                                    onClick={(e) => this.setState({ selectedChange: 'Remove a Tool From Service' })}
                                    name='requestedChange'
                                    id='requestedChange'
                                    className='rightRadios'
                                    placeholder=''
                                /> <span>Remove Tool From Service</span>
                            </div>
                            <div>
                                <Input
                                    type='radio'
                                    onClick={(e) => this.setState({ selectedChange: 'Other' })}
                                    name='requestedChange'
                                    id='requestedChange'
                                    className='rightRadios'
                                    placeholder=''
                                /> <span>Other</span>
                            </div>
                            <textarea
                                className='form-control marginTop normalInput'
                                onChange={(e) => this.setState({ comments: e.target.value })}
                                placeholder='Enter comments here'
                            />
                            <Button
                                color='primary'
                                className='button marginTop'
                                onClick={(e) => { this.handleSubmission() }}
                                disabled={this.state.loading ? true : false}
                            >
                                Request Change
                            </Button>
                        </Col>
                    </Row>
                </Container>
                <Modal show={this.state.showToast} onHide={this.handleClose}>
                    <Modal.Header >
                        <Modal.Title>Email Sent!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Thank you for requesting an asset change.  A <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> team member is working on your request.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
           </div>
        )
    }
}